import { Button } from "antd";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";

interface Props {
    isOn: boolean;
    onIsOnChange: (isOn: boolean) => void;
}

export const ShowInGraphTableButton = ({ isOn, onIsOnChange }: Props) => {
    const { t } = usePaldockTranslation("common");

    return null; // TODO - feature not finished

    return (
        <Button type={"primary"} danger={isOn} onClick={() => onIsOnChange(!isOn)}>
            {isOn ? t("cancel_show") : t("show_in_graph")}
        </Button>
    );
};
